export default __webpack_public_path__ + "static/media/watson-5.a748bf1f.png";